/**
 * Shared color palette and styling constants
 * Aligned with web-front app design system
 */

export const ADALONG_COLORS = {
  FLASH_RED: '#e62117',
  FLASH_BLUE: '#0005DC',
  FB_BLUE: '#3b5998',
  TWITTER_BLUE: '#1DA1F2',

  FLASH_PURPLE: '#8f4dfa',
  FLASH_PINK: '#f50b88',
  INSTAGRAM_PURPLE: '#833AB4',

  FLASH_GREEN: '#63c739',
  GREEN: '#228a2a',

  SMOOTH_WHITE: '#e0e0e0',
  LIGHT_WHITE: '#ffffff',

  DARKER_GRAY: '#343434',
  DARK_GRAY: '#4b4c4c',
  LIGHT_GRAY: '#909191',

  LIGHT_BLACK: '#323232',
  SMOOTH_BLACK: '#1b1b1b',
  SMOOTHER_BLACK: 'rgb(39, 39, 39)',
  DARK_BLACK: '#151515',
  ABSOLUTE_BLACK: '#000000',

  YELLOW: '#ffb600',
  LIGHT_YELLOW: '#e3fc73',
};

export const ThemeStyle = {
  background: {
    main: '#151515',
  },
  fonts: {
    primary: '"Public Sans", sans-serif',
  },
  button: {
    color: '#bbbbbb',
    hoveredColor: 'white',
  },
  textSizes: {
    small: 12,
    regular: 14,
    medium: 16,
    large: 18,
  },
};
